module.exports = __webpack_public_path__ + "static/media/slide-4.91b48c71.png";